module.exports = __webpack_public_path__ + "media/images/flags/1x1/lca-b9127bddcf113286724e572daa1c907e.svg";